"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var postchain_client_1 = require("postchain-client");
var account_1 = require("./account");
var single_signature_auth_descriptor_1 = require("./auth-descriptor/single-signature-auth-descriptor");
var User = /** @class */ (function () {
    function User(keyPair, authDescriptor) {
        this.keyPair = keyPair;
        this.authDescriptor = authDescriptor;
    }
    User.generateSingleSigUser = function (flags) {
        if (flags === void 0) { flags = [account_1.FlagsType.Account, account_1.FlagsType.Transfer]; }
        var keyPair = postchain_client_1.util.makeKeyPair();
        return new User(keyPair, new single_signature_auth_descriptor_1.default(keyPair.pubKey, flags));
    };
    return User;
}());
exports.default = User;
//# sourceMappingURL=user.js.map